module.exports = __webpack_public_path__ + "img/vue2-arriere_rouge.ec8b128e.png";